import { Directive, inject, NgZone, OnDestroy, OnInit, output } from '@angular/core';
import { IRect } from '@foblex/2d';


@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[appMouseTracker]'
})
export class MouseTrackerDirective implements OnInit, OnDestroy {
    mousePosition = output<IRect>();

    private unlistenFn?: () => void;
    private ngZone: NgZone = inject(NgZone);

    ngOnInit(): void {
        this.setupMouseTracking();
    }

    ngOnDestroy(): void {
        if (this.unlistenFn) {
            this.unlistenFn();
        }
    }

    private setupMouseTracking(): void {
        this.ngZone.runOutsideAngular(() => {
            const mouseMoveHandler = (event: MouseEvent) => {
                this.mousePosition.emit({
                    x: event.clientX,
                    y: event.clientY,
                } as IRect);
            };

            document.addEventListener('mousemove', mouseMoveHandler);

            this.unlistenFn = () => {
                document.removeEventListener('mousemove', mouseMoveHandler);
            };
        });
    }
}
